import { useEffect, useState } from 'react';

import useServerEcoCycle from '../../../api/useServerEconomicCycle';
import SideNav from '../../../components/misc/SideNav';
import SpinnerLoading from '../../../components/misc/SpinnerLoading';
import TabNav, { TabsAttr } from '../../../components/navigation/TabNav';
import { OrderInterface } from '../../../interfaces/ServerInterfaces';
import Details from './Details';
import Opperations from './Opperations';
import Tickets from './Tickets';

interface OrderDetail {
  id?: number
  updState: Function
}

const PosOrderDetails = ({ id, updState }: OrderDetail) => {
  const { getOrder, order, isLoading } = useServerEcoCycle()
  const [current, setCurrent] = useState('details')
  const tabs: TabsAttr[] = [
    {
      name: 'Detalles',
      current: current === 'details',
      href: 'details',
    },
    {
      name: 'Tickets',
      current: current === 'ticket',
      href: 'ticket',
    },
    {
      name: 'Trazas',
      current: current === 'opp',
      href: 'opp',
    },
  ]
  useEffect(() => {
    id && getOrder(id)
  }, [])

  if (isLoading)
    return (
      <div className="flex h-96 items-center justify-center">
        <SpinnerLoading />
      </div>
    )

  return (
    <>
      {/* <TabNav tabs={tabs} action={setCurrent} /> */}
      <section className="grid grid-cols-12">
        <SideNav tabs={tabs} action={setCurrent} className="col-span-2" />
        <section className="col-span-10 h-[500px] overflow-auto px-5 scrollbar-thin">
          {current === 'details' && (
            <Details
              item={order}
              updateOrderState={(order: OrderInterface) =>
                updState(order, true)
              }
            />
          )}
          {current === 'opp' && <Opperations records={order?.records} />}
          {current === 'ticket' && <Tickets tickets={order?.tickets ?? []} />}
        </section>
      </section>
    </>
  )
}

export default PosOrderDetails
